var _style, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 18.2 15.2",
    style: {
      enableBackground: "new 0 0 18.2 15.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#C4C4C4;}\n\t.st1{fill:none;stroke:#323232;stroke-linecap:round;stroke-linejoin:round;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{fill:#323232;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M14.4,13.5H17c0.4,0,0.8-0.4,0.8-1v-11c0-0.6-0.3-1-0.8-1l-15.7,0c-0.4,0-0.8,0.4-0.8,1v11c0,0.6,0.3,1,0.8,1 h2.6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M14.4,13.5H17c0.4,0,0.8-0.4,0.8-1v-11c0-0.6-0.3-1-0.8-1l-15.7,0c-0.4,0-0.8,0.4-0.8,1v11c0,0.6,0.3,1,0.8,1 h2.6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M4.1,10L2.2,4.4H3l1.3,4C4.4,8.8,4.4,9,4.5,9c0-0.1,0.1-0.3,0.2-0.6l1.3-4h0.7L4.7,10H4.1z M10.6,10l-0.5-1.4 H7.9L7.5,10H6.7l2-5.6h0.6l2,5.6H10.6z M9.9,8L9.2,5.9C9.1,5.7,9.1,5.5,9,5.4C9,5.6,8.9,5.8,8.9,5.9L8.1,8H9.9z M12.4,10V4.4h2.2 c0.6,0,1.1,0.2,1.3,0.5c0.3,0.3,0.4,0.7,0.4,1.1c0,0.4-0.1,0.7-0.3,1c-0.2,0.3-0.5,0.5-1,0.6l1.2,2.4h-0.8l-1.2-2.4h-1.2V10H12.4z  M13.1,7h1.5c0.4,0,0.6-0.1,0.8-0.3c0.2-0.2,0.3-0.4,0.3-0.7c0-0.3-0.1-0.5-0.2-0.7C15.2,5.1,15,5,14.6,5h-1.5V7z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M3.9,13h10.6c0.3,0,0.5,0.2,0.5,0.5v1.2c0,0.3-0.2,0.5-0.5,0.5H3.9c-0.3,0-0.5-0.2-0.5-0.5v-1.2 C3.4,13.2,3.7,13,3.9,13z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVar);
export default __webpack_public_path__ + "static/media/VAR.1795787e800487f1f9fdf82e4eeaeff7.svg";
export { ForwardRef as ReactComponent };